import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios";


export async function getEquipment(equipmentId) {
  let url = `${BASE_URL}/api/equipment/${equipmentId}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getEquipments({ q, page, perPage }) {
  let url = `${BASE_URL}/api/equipment?`;
  url += getQueryParamsString({ q, page, perPage });

  const res = await axiosInstance.get(url)
  return res.data.Data;
}


export async function createEquipment(equipment) {
  let url = `${BASE_URL}/api/equipment`;

  const res = await axiosInstance.post(url, JSON.stringify(equipment))
  return res.data.Data;
}

export async function updateEquipment(equipment) {
  let url = `${BASE_URL}/api/equipment`;

  const res = await axiosInstance.put(url, equipment)
  return res.data.Data;
}

export async function deleteEquipment(equipmentId) {
  let url = `${BASE_URL}/api/equipment/${equipmentId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}

export async function sendDocumentLinks(equipmentId, contactData) {
  let url = `${BASE_URL}/api/equipment/${equipmentId}/send-document-links`;

  const res = await axiosInstance.post(url, contactData)
  return res.data.Data;
}

export async function getDocumentsByToken(token) {
  let url = `${BASE_URL}/api/equipment/documents/${token}`;

  const res = await axiosInstance.get(url)
  return res.data.Data;
}